import React from "react"
import Tooltip from "aldoo-ra/Tooltip"
import { InformationCircleIcon } from "@heroicons/react/24/outline"

/**
 * FieldLabel - Renders field label with optional tooltip for description
 *
 * Displays the field label with a tooltip icon that shows the field description on hover.
 * This component is used at the field render level in groups.jsx to provide consistent
 * label+description rendering for all field editors.
 *
 * @param {Object} props
 * @param {Object} props.field - The field configuration object
 * @param {boolean} props.isRequired - Whether the field is required
 * @param {boolean} props.readOnly - Whether the field is read-only
 */
export default function FieldLabel({ field, isRequired, readOnly }) {
  if (!field?.label) return null

  return (
    <div className="flex items-center gap-2 mb-2">
      <label className="block font-semibold text-admin_text">
        {field.label}
        {isRequired && <span className="ml-1 text-admin_error">*</span>}
        {readOnly && (
          <span className="ml-2 text-xs font-normal text-admin_warning bg-admin_warning/10 px-2 py-0.5 rounded">
            Read-only
          </span>
        )}
      </label>

      {field.description && (
        <Tooltip
          content={field.description}
          position="top"
          display="inline-flex"
        >
          <InformationCircleIcon className="w-4 h-4 text-admin_text_secondary hover:text-admin_primary cursor-help transition-colors" />
        </Tooltip>
      )}
    </div>
  )
}
